export default class GTM {

  static doDataLayerPush (data) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }

}

